<app-debug-bar></app-debug-bar>
<router-outlet></router-outlet>

<magieno-floating-button [menuItems]="menuItems" (menuItemClicked)="menuItemClicked($event)">
  <div closedIcon><i class="fal fa-toolbox"></i></div>
  <div openIcon><i class="fal fa-times"></i></div>
</magieno-floating-button>